/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaTag/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaTag({
  children,
  viewPath = "/DesignSystem/TysiaTag",
  display = "flex",
  alignSelf = "flex-start",
  backgroundColor,
  marginTop = 0,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  paddingTop = 0.5,
  paddingBottom = 0.5,
  borderColor,
  cursor,
  maxWidth,
  type,
  style,
  size,
  color
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBlue200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.200'
        })
let dtColorsOrange200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.200'
        })
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
let dtColorsRed200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.200'
        })
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let backgroundColorOrdtColorsWhite = backgroundColor ?? dtColorsWhite
let borderColorOrdtColorsNeutral300 = borderColor ?? dtColorsNeutral300
  return (<React.Fragment
>
<div
  data-testid="TysiaTag.Horizontal"
  data-view-path={viewPath}
 style={{'--d-1-ZBFxUF': display,'--as-2-ZBFxUF': alignSelf,'--mt-4-ZBFxUF': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-5-ZBFxUF': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-6-ZBFxUF': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-7-ZBFxUF': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--pt-8-ZBFxUF': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-9-ZBFxUF': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--c-11-ZBFxUF': cursor,'--mw-12-ZBFxUF': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--bc-10-ZBFxUF': type === "grey" && style === "filled" ? dtColorsNeutral200 : type === "blue" && style === "filled" ? dtColorsBlue200 : type === "orange" && style === "filled" ? dtColorsOrange200 : type === "green" && style === "filled" ? dtColorsGreen200 : type === "red" && style === "filled" ? dtColorsRed200 : type === "brand" && style === "filled" ? dtColorsBrandBase : type === "grey" ? dtColorsNeutral400 : type === "blue" ? dtColorsBlue200 : type === "orange" ? dtColorsOrange200 : type === "green" ? dtColorsGreen200 : type === "noteYellow" ? "#C99A2D" : type === "brand" ? dtColorsBrandBase : type === "red" ? dtColorsRed200 : borderColorOrdtColorsNeutral300,'--bc-3-ZBFxUF': type === "grey" && style === "filled" ? dtColorsNeutral200 : type === "blue" && style === "filled" ? dtColorsBlue200 : type === "orange" && style === "filled" ? dtColorsOrange200 : type === "green" && style === "filled" ? dtColorsGreen200 : type === "red" && style === "filled" ? dtColorsRed200 : type === "brand" && style === "filled" ? dtColorsBrandBase : type === "green" ? dtColorsGreen200 : type === "noteYellow" ? "#C99A2D" : type === "brand" ? dtColorsBrandBase : type === "red" ? dtColorsRed200 : style === "outline" ? dtColorsWhite : style === "filled" ? dtColorsNeutral600 : backgroundColorOrdtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 type={type}
 style={style}
 size={size}
 color={color}
>
{children}
</Children>
</div>
</React.Fragment>)
}